import { atom } from 'recoil';
import React from 'react';

let globalBottomSheet = atom<any>({
  key: 'globalBottomSheet',
  default: {
    open: false,
    title: '',
    onClose: () => {},
    onConfirm: () => {},
    children: '',
    confirmText: '',
  },
});

export { globalBottomSheet };
